
import { defineComponent, ref, onMounted, watch, computed } from "vue";
import { Course, GetCourseResponse } from "@/types";
import { usePlugin } from "@/plugins";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default defineComponent({
  name: "InputCourse",
  props: {
    modelValue: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { axios, error } = usePlugin();
    const courses = ref<Course[]>([]);
    const courseId = ref("");
    const isLoading = ref(false);
    const loadCourses = async () => {
      isLoading.value = true;
      try {
        const result = await axios.post<GetCourseResponse>(
          "api/v1/services/course/get",
          {} as GetCourseResponse
        );
        courses.value = result.data.courses ?? [];
      } catch (e) {
        error(e);
      } finally {
        isLoading.value = false;
      }
    };
    const onInput = (value: { value: string }) => {
      emit("update:modelValue", value.value);
    };

    const rules = computed(() => {
      return {
        courseId: { required: requiredIf(() => props.required === true) },
      };
    });
    const v$ = useVuelidate(rules, { courseId }, { $lazy: true });

    watch(
      () => props.modelValue,
      () => (courseId.value = props.modelValue ?? "")
    );
    watch(
      () => props.required,
      () => {
        v$.value.$reset();
        v$.value.$touch();
      }
    );

    onMounted(() => {
      loadCourses();
      courseId.value = props.modelValue ?? "";
    });

    return { courses, onInput, courseId, v$, isLoading };
  },
});
